import { SearchListItem } from '@finance-lab/utils/types'

export function getSearchEntityLabel(entity: SearchListItem): string {
    if (entity.entityType === 'Issue') {
        return entity.instrumentName ?? ''
    }
    return entity.name ?? ''
}
